<template lang="pug">
	#resultado

		el-row.tela(v-if="loading")
			loading-icon.spinner(:title="''", :height="'150'", :width="'150'")

		el-row.tela(v-if="!loading && imoveis.length <= 0")
			el-col(:span="24")
				h1(v-if="this.tipoPesquisa !== 'Cod. Imóvel'") Nenhum imóvel vinculado ao {{this.tipoPesquisa}} {{this.$route.query.codigoPesquisa}} foi encontrado.
				h1(v-if="this.tipoPesquisa === 'Cod. Imóvel'") Nenhum imóvel com o código {{this.$route.query.codigoPesquisa}} foi encontrado.

		div(v-if="!loading && imoveis.length > 0")

			mixin status-car()
				.aguardando-analise(v-if='imovel.condicaoInscricao.codCondicao === "AA"')
					clock-outline-icon(:title="''", :width="'30'", :height="'30'").icon-aguardando-analise

				.circle-status.circle-status-blue(v-if='imovel.condicaoInscricao.codCondicao === "EA" || imovel.condicaoInscricao.codCondicao === "EAA"')
					eye-icon(:title="''", :width="'21'", :height="'21'").icon-status-car

				.circle-status.circle-status-orange(v-if='imovel.condicaoInscricao.codCondicao === "AARA" || imovel.condicaoInscricao.codCondicao === "RAA"')
					exclamation-icon(:title="''", :width="'21'", :height="'21'").icon-status-car

				.circle-status.circle-status-silver(v-if='imovel.condicaoInscricao.codCondicao != "AARA" && imovel.condicaoInscricao.codCondicao != "RAA" && imovel.condicaoInscricao.codCondicao != "AA" && imovel.condicaoInscricao.codCondicao != "EA" && imovel.condicaoInscricao.codCondicao != "EAA"')
					minus-circle-outline-icon(:title="''", :width="'21'", :height="'21'").icon-status-car

				.label-status  {{imovel.condicaoInscricao && imovel.condicaoInscricao.nomCondicao.length > 18 ? imovel.condicaoInscricao.nomCondicao.slice(0,15) + '...' : imovel.condicaoInscricao.nomCondicao}}

			mixin status-pra()
				el-tag {{imovel.regularidade.nome.length > 25 ? imovel.regularidade.nome.slice(0,22) + '...' : imovel.regularidade.nome}}

			.container
				el-row
					el-col(:sm='24', :md='9' :lg= '10')
						.resultadoNumero Exibindo {{exibicaoImoveis()}} de {{qtdImoveis}} resultado(s) para a consulta
							b  "{{$route.query.codigoPesquisa}}"

				.card-resultado(v-for="imovel in imoveis" @click="goToDadosQuery($route.query.codigoPesquisa, imovel)")
					el-row
						el-col(:sm='24', :md='9' :lg= '10').aling-center-sm.aligin-bottom
							el-row
								.codigo-imovel {{imovel.codigo}}
							el-row
								el-col(:sm='24' :md='9').aling-center-sm
									.nome-imovel {{imovel.nomeImovel}}

						el-col(:sm='24' :md='5' :lg='5').aling-center-sm.aligin-bottom
							el-row
								.pra PRA
							el-row.btn-center
								el-tag.imovel-regularidade(v-show="imovel.regularidade.nome.length === 0")
									loading-icon.spinner.regularidade(:title="''", :height="'25'", :width="'25'")
								div.imovel-regularidade(v-show="imovel.regularidade.nome.length <= 25 && imovel.regularidade.nome.length > 0")
									+status-pra
								el-tooltip.imovel-regularidade.item(v-show="imovel.regularidade.nome.length > 25", effect='dark', :content='imovel.regularidade.nome', placement='top')
									+status-pra

						el-col(:sm='9' :md='10' :lg='9').status-car-center
							el-row
								el-col(:sm='24' :md='24', :lg='24')
									.car CAR
							el-row
								el-col(:sm='6' :md='6', :lg='6')

									div(v-if='imovel.totalRestricoes === 0')
										.circle-status.circle-status-green
											lock-open-icon(:title="''", :width="'17'", :height="'17'").aling-icon
										.label-status Sem restrição

									div(v-if='imovel.totalRestricoes > 0')
										.circle-status.circle-status-red
											lock-alert-icon(:title="''", :width="'17'", :height="'17'").aling-icon
										.label-status(v-if='imovel.totalRestricoes === 1') {{imovel.totalRestricoes}} restrição
										.label-status(v-if='imovel.totalRestricoes > 1') {{imovel.totalRestricoes}} restrições

								el-col(:sm='1' :md='1', :lg='1').linha-vertical-right

								el-tooltip.item(v-if="imovel.condicaoInscricao && imovel.condicaoInscricao.nomCondicao.length > 18", effect='dark', :content='imovel.condicaoInscricao.nomCondicao', placement='top')
									el-col(:sm='10' :md='9', :lg='9')
										+status-car

								el-col(v-if="imovel.condicaoInscricao && imovel.condicaoInscricao.nomCondicao.length <= 18", :sm='10' :md='9', :lg='9')
									+status-car

								el-col(:sm='1' :md='1', :lg='1').linha-vertical-left

								el-col(:sm='6' :md='5', :lg='5')
									div(v-if="imovel.statusImovel== 'AT'")
										.circle-status.circle-status-green
											check-icon(:title="''").aling-icon
										.label-status Ativo
									div(v-if="imovel.statusImovel== 'PE'")
										.circle-status.circle-status-red
											minus-icon(:title="''", :width="'24'", :height="'24'").aling-icon-pendente
										.label-status Pendente

				el-pagination(layout="prev, pager, next", :total="qtdImoveis", :current-page="getCurrentPage()" @current-change="buscarPagina")

</template>

<script>

import LockOpenIcon from 'vue-material-design-icons-size/LockOpen.vue'
import LockAlertIcon from 'vue-material-design-icons-size/LockAlert.vue'
import ClockOutlineIcon from 'vue-material-design-icons-size/ClockOutline.vue'
import CheckIcon from 'vue-material-design-icons-size/Check.vue'
import EyeIcon from 'vue-material-design-icons-size/Eye.vue'
import ExclamationIcon from 'vue-material-design-icons-size/Exclamation.vue'
import MinusCircleOutlineIcon from 'vue-material-design-icons-size/MinusCircleOutline.vue'
import MinusIcon from 'vue-material-design-icons-size/Minus.vue'
import RouterMixin from '@/utils/mixins/RouterMixin'
import ImoveisService from '../../utils/services/imoveis.service'
import LoadingIcon from 'vue-material-design-icons-size/Loading'

export default {

	components: {
		LoadingIcon,
		LockOpenIcon,
		ClockOutlineIcon,
		CheckIcon,
		EyeIcon,
		ExclamationIcon,
		MinusCircleOutlineIcon,
		LockAlertIcon,
		MinusIcon
	},

	mixins: [RouterMixin],

	data() {

		return {
			imoveis: [],
			qtdImoveis: null,
			loading: true,
			tipoPesquisa: 'CPF'
		}

	},

	mounted() {

		this.$parent.$emit('navBar', true)
		var value = this.$route.query.codigoPesquisa
		var page = this.$route.query.pagina
		this.contarImoveis(value)
		this.pesquisar(value, page)

	},

	methods: {

		maiorQue25(imovel) {

			return imovel.regularidade.nome.length <= 25

		},

		getCurrentPage: function() {

			return parseInt(this.$route.query.pagina)

		},

		updateLoading: function(value) {

			this.loading = value

		},

		buscaStatus: function(imovel) {

			ImoveisService.getStatus(imovel.id).then(({ data }) => {

				imovel.regularidade = data

			})

		},

		buscarPagina: function(value) {

			this.$router.push({ query: { codigoPesquisa: this.$route.query.codigoPesquisa, pagina: value } })

		},

		contarImoveis: function(value) {

			ImoveisService.countImoveis(value.replace('/', '')).then(({ data }) => {

				this.qtdImoveis = data

			})

		},

		exibicaoImoveis: function() {

			let paginaAtual = this.$route.query.pagina
			let totalImoveis = this.qtdImoveis
			let inicioPagina = (totalImoveis <= 10) ? 1 : (paginaAtual * 10 - 9)
			let fimPagina = (totalImoveis <= 10) ? totalImoveis : ((paginaAtual * 10) < totalImoveis ? (paginaAtual * 10) : totalImoveis)

			return inicioPagina + ' a ' + fimPagina

		},

		pesquisar: function(value, page) {

			this.loading = true

			var that = this
			ImoveisService.getImoveis(value.replace('/', ''), page).then(({ data }) => {

				that.imoveis = data
				that.loading = false

				for(const imovel of that.imoveis) {

					that.buscaStatus(imovel)

				}

			}).catch(function() {

				that.loading = false

				that.$notify({
					title: 'Erro ao buscar imóveis',
					type: 'error'
				})

			})

			if(that.$route.query.codigoPesquisa === undefined) {

				that.tipoPesquisa = 'CPF'

			}

			if(that.$route.query.codigoPesquisa.length <= 14) {

				that.tipoPesquisa = 'CPF'

			}

			if(that.$route.query.codigoPesquisa.length <= 20 && that.length > 14) {

				that.tipoPesquisa = 'CNPJ'

			}

			if(that.$route.query.codigoPesquisa.length > 20) {

				that.tipoPesquisa = 'Cod. Imóvel'

			}

		}
	},

	watch: {

		'$route.query.codigoPesquisa': function(newVal) {

			var that = this

			this.pesquisar(newVal, this.$route.query.pagina)

			if(newVal.codigoPesquisa === undefined) {

				that.tipoPesquisa = 'CPF'

			}

			if(newVal.length <= 14) {

				that.tipoPesquisa = 'CPF'

			}

			if(newVal.length <= 20 && newVal.length > 14) {

				that.tipoPesquisa = 'CNPJ'

			}

			if(newVal.length > 20) {

				that.tipoPesquisa = 'Cod. Imóvel'

			}

		},

		'$route.query.pagina': function(newVal) {

			var that = this

			this.pesquisar(this.$route.query.codigoPesquisa, newVal)

			if(this.$route.query.codigoPesquisa === undefined) {

				that.tipoPesquisa = 'CPF'

			}

			if(this.$route.query.codigoPesquisa.length <= 14) {

				that.tipoPesquisa = 'CPF'

			}

			if(this.$route.query.codigoPesquisa.length <= 20 && newVal.length > 14) {

				that.tipoPesquisa = 'CNPJ'

			}

			if(this.$route.query.codigoPesquisa.length > 20) {

				that.tipoPesquisa = 'Cod. Imóvel'

			}

		}
	},

	destroyed() {

		this.$parent.$emit('navBar', false)

	}

}
</script>

<style scoped>

	.container {
		padding-top: 110px;
		padding-left: 98px;
		padding-right: 98px;
	}

	.card-resultado {
		background-color: #FFFFFF;
		border: 1px solid #E0E0E0;
		padding: 15px 0 21px 15px;
		border-radius: 5px;
		margin-bottom: 20px;
		cursor: pointer;
	}

	.card-resultado:hover {
		box-shadow: 0 1px 2px rgba(0, 0, 0, .1);
	}

	.codigo-imovel {
		color: #424242;
		font-size: 16px;
	}

	.pra {
		font-size: 13px;
		color: #9E9E9E;
		margin-bottom: 11px;
	}

	.car {
		font-size: 13px;
		color: #9E9E9E;
	}

	.nome-imovel {
		color: #9E9E9E;
		font-size: 13px;
	}

	.el-tag {
		background-color: #FFFFFF;
		padding: 0 10px;
		height: 32px;
		line-height: 30px;
		font-size: 12px;
		color: #424242;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		border: 1px solid #E0E0E0;
		white-space: nowrap;
		border-radius: 16px;
	}

	.status-pra {
		z-index: 1000;
		background-color: #FFFFFF;
		padding: 0 10px;
		height: 32px;
		line-height: 30px;
		font-size: 12px;
		color: #424242;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		border: 1px solid #E0E0E0;
		white-space: nowrap;
		border-radius: 16px;
	}

	.circle-status {
		width: 25px;
		height: 25px;
		border-radius: 12px;
		margin-bottom: 5px;
		margin-left: auto;
		margin-right: auto;
	}

	.circle-status-red {
		background-color: #E53935;
	}

	.circle-status-green {
		background-color: #43A047;
	}

	.circle-status-blue {
		background-color: #1492E6;
	}

	.circle-status-orange {
		background-color: #FB8C00;
	}

	.circle-status-silver {
		background-color: #aaaaaa;
	}

	.aling-icon {
		padding: 3px 0 0 4px;
		color: #FFFFFF;
	}

	.aling-icon-pendente {
		padding: 7px 0 0 1px;
		color: #FFFFFF;
	}

	.icon-status-car {
		color: #FFFFFF;
		margin-top: 5px;
		margin-left: 2px;
	}

	.aguardando-analise {
		width: 30px;
		height: 30px;
		margin-left: auto;
		margin-right: auto;
	}

	.imovel-regularidade {
		position: absolute;
	}

	.icon-aguardando-analise {
		color: #FFA726;
		margin-top: 10px;
	}

	.label-status {
		font-size: 12px;
		color: #424242;
		text-align: center;
	}

	.linha-vertical-right {
		height: 45px;
		border-right: 1px solid #E0E0E0;
	}

	.linha-vertical-left {
		height: 45px;
		border-left: 1px solid #E0E0E0;
	}

	@media only screen and (max-width: 767px) {
		.linha-vertical-left {
			display: none;
		}

		.linha-vertical-right {
			display: none;
		}
	}

	@media only screen and (max-width: 991px) {
		.aling-center-sm {
			text-align: center;
		}

		.aligin-bottom {
			margin-bottom: 10px;
		}

		.car {
			display: none;
		}

		.pra {
			display: none;
		}

		.btn-center {
			-webkit-box-pack: center;
			-ms-flex-pack: center;
			justify-content: center;
			display: -webkit-box;
			display: -ms-flexbox;
			display: flex;
		}

		.status-car-center {
			width: 100%;
			display: block;
			margin-left: auto;
			margin-right: auto;
		}
	}

	@media only screen and (max-width: 767px) {
		.codigo-imovel {
			font-size: 14px;
		}
	}

	.tela {
		height: 93.7vh;
		width: 100vw;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		text-align: center;
	}

	.loading-icon {
		margin: 0 auto;
		height: 150px;
		width: 150px;
	}

	.regularidade {
		margin: 0 auto;
		height: 25px;
		width: 25px;
	}

	#resultado {
		min-height: 92.9vh;
	}

	.resultadoNumero {
		margin-bottom: 30px;
	}

	.el-pagination {
		margin-bottom: 15px;
	}

</style>



// WEBPACK FOOTER //
// src/components/views/Resultados.vue